/**
 * @generated SignedSource<<385dde3738f08f0d41b7f5f091f63ea9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditProjectBudgetFormQuery$variables = {
  projectId: number;
};
export type EditProjectBudgetFormQuery$data = {
  readonly current_user: {
    readonly id: number;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectBudgetForm_user">;
  } | null | undefined;
  readonly projects_by_pk: {
    readonly id: number;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectBudgetForm_project">;
  } | null | undefined;
};
export type EditProjectBudgetFormQuery = {
  response: EditProjectBudgetFormQuery$data;
  variables: EditProjectBudgetFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v6 = [
  (v1/*: any*/),
  (v3/*: any*/),
  {
    "alias": "blended_rate",
    "args": null,
    "kind": "ScalarField",
    "name": "blended_rate_private",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "blended_rate_card",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "role_charge_out_rates",
    "kind": "LinkedField",
    "name": "role_charge_out_rates",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rate_card_id",
        "storageKey": null
      },
      {
        "alias": "charge_out_rate",
        "args": null,
        "kind": "ScalarField",
        "name": "charge_out_rate_private",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimated_minutes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditProjectBudgetFormQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "users",
        "kind": "LinkedField",
        "name": "current_user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProjectBudgetForm_user"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "projects_by_pk",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProjectBudgetForm_project"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditProjectBudgetFormQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "users",
        "kind": "LinkedField",
        "name": "current_user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "permissions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "accounts",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "default_full_time_minutes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "roles",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "rate_cards",
                "kind": "LinkedField",
                "name": "rate_cards",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "projects_by_pk",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pricing_model",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rate_type",
            "storageKey": null
          },
          {
            "alias": "total_budget",
            "args": null,
            "kind": "ScalarField",
            "name": "total_budget_private",
            "storageKey": null
          },
          {
            "alias": "no_phase_revenue_budget",
            "args": null,
            "kind": "ScalarField",
            "name": "no_phase_revenue_budget_private",
            "storageKey": null
          },
          {
            "alias": "expenses_budget",
            "args": null,
            "kind": "ScalarField",
            "name": "expenses_budget_private",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emoji",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "is_template",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "budget_method",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_rates",
            "kind": "LinkedField",
            "name": "project_rates",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": "projectId",
                "args": null,
                "kind": "ScalarField",
                "name": "project_id",
                "storageKey": null
              },
              {
                "alias": "roleId",
                "args": null,
                "kind": "ScalarField",
                "name": "role_id",
                "storageKey": null
              },
              {
                "alias": "rate",
                "args": null,
                "kind": "ScalarField",
                "name": "rate_private",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "rate_cards",
            "kind": "LinkedField",
            "name": "rate_card",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_roles",
            "kind": "LinkedField",
            "name": "project_roles",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_members",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "clients",
            "kind": "LinkedField",
            "name": "client",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internal",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image_key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "website",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "order_by",
                "value": {
                  "date": "asc"
                }
              }
            ],
            "concreteType": "other_costs",
            "kind": "LinkedField",
            "name": "other_costs",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              {
                "alias": "date",
                "args": null,
                "kind": "ScalarField",
                "name": "date_runn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "charge",
                "storageKey": null
              },
              {
                "alias": "phaseId",
                "args": null,
                "kind": "ScalarField",
                "name": "phase_id",
                "storageKey": null
              }
            ],
            "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "phases",
            "kind": "LinkedField",
            "name": "phases",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": "revenue_budget",
                "args": null,
                "kind": "ScalarField",
                "name": "revenue_budget_private",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "phase_roles",
                "kind": "LinkedField",
                "name": "phase_roles",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "roles",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": "start_date",
                "args": null,
                "kind": "ScalarField",
                "name": "start_date_runn",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac23414247a1760323f9a6a504a51a43",
    "id": null,
    "metadata": {},
    "name": "EditProjectBudgetFormQuery",
    "operationKind": "query",
    "text": "query EditProjectBudgetFormQuery(\n  $projectId: Int!\n) {\n  current_user {\n    id\n    ...ProjectBudgetForm_user\n  }\n  projects_by_pk(id: $projectId) {\n    id\n    ...ProjectBudgetForm_project\n  }\n}\n\nfragment OtherExpenseEditRow_project on projects {\n  id\n  phases {\n    id\n    name\n    color\n  }\n}\n\nfragment OtherExpensesEditor_project on projects {\n  id\n  ...OtherExpenseEditRow_project\n}\n\nfragment PhaseAndRoleEditor_project on projects {\n  id\n  phases {\n    id\n    name\n    color\n    start_date: start_date_runn\n    phase_roles {\n      id\n      role {\n        id\n        name\n      }\n      estimated_minutes\n    }\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  members {\n    id\n    role_id\n  }\n}\n\nfragment PhaseEditor_project on projects {\n  id\n  no_phase_revenue_budget: no_phase_revenue_budget_private\n  phases {\n    id\n    name\n    color\n    start_date: start_date_runn\n    revenue_budget: revenue_budget_private\n  }\n}\n\nfragment ProjectBudgetForm_project on projects {\n  id\n  name\n  active\n  pricing_model\n  rate_type\n  total_budget: total_budget_private\n  no_phase_revenue_budget: no_phase_revenue_budget_private\n  expenses_budget: expenses_budget_private\n  emoji\n  is_template\n  budget_method\n  project_rates {\n    id\n    projectId: project_id\n    roleId: role_id\n    rate: rate_private\n  }\n  rate_card {\n    id\n    name\n    blended_rate: blended_rate_private\n    blended_rate_card\n    role_charge_out_rates {\n      role_id\n      rate_card_id\n      charge_out_rate: charge_out_rate_private\n    }\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  members {\n    id\n    role_id\n  }\n  client {\n    internal\n    id\n    image_key\n    website\n  }\n  other_costs(order_by: {date: asc}) {\n    id\n    name\n    date: date_runn\n    cost\n    charge\n    phaseId: phase_id\n  }\n  phases {\n    id\n    revenue_budget: revenue_budget_private\n    phase_roles {\n      id\n      role {\n        id\n        name\n      }\n      estimated_minutes\n    }\n  }\n  ...PhaseEditor_project\n  ...PhaseAndRoleEditor_project\n  ...OtherExpensesEditor_project\n}\n\nfragment ProjectBudgetForm_user on users {\n  id\n  permissions\n  account {\n    id\n    default_full_time_minutes\n    roles {\n      id\n      name\n      active\n    }\n    rate_cards {\n      id\n      name\n      blended_rate: blended_rate_private\n      blended_rate_card\n      role_charge_out_rates {\n        role_id\n        rate_card_id\n        charge_out_rate: charge_out_rate_private\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "abc8c0686dd5aedd1417038ece2e3b8f";

export default node;
